import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { MapHelperService } from "../../../../../services/map-helper.service";
import { EstatusJSON } from "../../../shared/models/EstatusJSON";
import { geofenceListItem } from "../../models/geofenceListItem";
import { PanelDetailGeofencesService } from "../../services/Panel-Detail-Geofences.service";
import { PanelGeofencesService } from "../../services/Panel-Geofences.service";
import { Observable, Subscription } from "rxjs";
import { PanelAddGeofencesService } from "../../services/Panel-Add-Geofences.service";
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from "@angular/material/legacy-tabs";
import { MediaMatcher } from "@angular/cdk/layout";
import { ToastrService } from "ngx-toastr";
import { GeofencesService } from "../../services/Geofences.service";
import { LayerDTO } from "src/app/features/locations-map/models/LayerDTO";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { PanelInternalLayerService } from "src/app/features/locations-map/services/Panel-Internal-Layer.service";
@Component({
  selector: "panel-geofences",
  templateUrl: "./panel-geofences.component.html",
  styleUrls: ["./panel-geofences.component.css"],
})
export class PanelGeofencesComponent implements OnInit, OnDestroy {
  public $Items: geofenceListItem[];
  public $ItemsGet: geofenceListItem[];
  finder: string = "";
  public isMapix: boolean = false;
  public isLoading: boolean = false;
  filter: boolean = false;
  PinSelected: any = null;
  isAdmin: boolean;
  roles: string;
  $ItemsActives: [] = [];
  $ItemsInactives: [] = [];
  subscription_GetList: Subscription;
  subscription_getLoading: Subscription;
  selectedTabIndex: number = 0;

  
  dataGeoJson: [];
  dataGeoJsonCentroides: any = {
    type: "FeatureCollection",
    features: [],
  };

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;
  subscription_get: Subscription;
  suscription_GetLayerDataByNameGeoJSON: Subscription;
  subscription_GetAllGeofencesGeoJson: Subscription;
  subscription_findByIdentifier: Subscription;


  constructor(
    private sessionService: SessionService,
    private panelGeofencesService: PanelGeofencesService,
    private geofenceService: GeofencesService,
    private panelDetailGeofencesService: PanelDetailGeofencesService,
    private mapHelperService: MapHelperService,
    private panelAddGeofenceService: PanelAddGeofencesService,
    changeDetectorRef: ChangeDetectorRef,
    private panelInternalLayerService: PanelInternalLayerService,
    private geofencesService: GeofencesService,
    media: MediaMatcher,
    private toastService: ToastrService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 761px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.subscription_getLoading = this.panelGeofencesService
      .getLoading()
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });
  }

  ngOnInit(): void {
    this.panelGeofencesService.setLoading(true);
    this.GetGeofences();
    this.getGeofencesList();
    this.checkingURL();
    
  }

  ngAfterViewInit(): void {
    this.GetGeofenceLayer();
  }

  GetGeofenceLayer(){
    if (this.panelInternalLayerService.capas.length > 0) {
      this.panelInternalLayerService.ActivateLayer(this.panelInternalLayerService.geofenceLayer);
    }else{
      setTimeout(() => {
        this.panelInternalLayerService.ActivateLayer(this.panelInternalLayerService.geofenceLayer);
      }, 4000);
    }
  }

  ngOnDestroy() {
    if (this.subscription_GetList) this.subscription_GetList.unsubscribe();
    if (this.subscription_get) this.subscription_get.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    if (this.suscription_GetLayerDataByNameGeoJSON)
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
    if (this.subscription_GetAllGeofencesGeoJson)
      this.subscription_GetAllGeofencesGeoJson.unsubscribe();
    if (this.subscription_findByIdentifier)
      this.subscription_findByIdentifier.unsubscribe();
  }
  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  selectTab(event: MatTabChangeEvent) {
    if (event.index == 0) {
      this.selectedTabIndex = 0;
    } else if (event.index == 1) {
      this.selectedTabIndex = 1;
    } else {
      this.selectedTabIndex = 2;
    }
  }

  onFindGeofence(event) {
    this.panelGeofencesService.setLoading(true);
    if (!this.mobileQuery.matches) {
      this.fullScreen = true;
    }
    console.log(event);
    var texto = event.target.value.toLowerCase();
    if (texto.length == 0) {
      this.filter = false;
      this.$Items = this.$ItemsGet;
      console.log("reset filter...");
      this.panelGeofencesService.setLoading(false);
    } else {
      this.filter = true;
      this.$Items = this.$ItemsGet.filter((item) => {
        return ( item.name.toLowerCase().includes(texto) && (item.status === 1 || item.status === 0) );
      });
      this.panelGeofencesService.setLoading(false);
    }
    // if (texto.length > 0) {
    //   this.subscription_findByIdentifier = this.panelGeofencesService.findByIdentifier(texto).subscribe((arg) => {
    //     console.log(arg.result);
    //     this.$Items = arg.result as geofenceListItem[];
    //     this.panelGeofencesService.setLoading(false);
    //   }).catch((error) => {
    //     this.panelGeofencesService.setLoading(false);
    //   });
    // }
  }

  getGeofencesList() {
    console.log("GetGeofencesList");
    this.subscription_GetList = this.panelGeofencesService
      .getList()
      .subscribe((data: EstatusJSON) => {
        if (data.isSuccess == true) {
          this.$Items = data.result;
          this.$ItemsActives = data.result.filter(
            (item) => item.status === 1 && typeof item !== "undefined"
          );
          this.$ItemsInactives = data.result.filter(
            (item) => item.status === 0 && typeof item !== "undefined"
          );
          this.$ItemsGet = this.$Items;
          console.log(this.$ItemsActives);
        }
        this.panelGeofencesService.setLoading(false);
      });
  }
  ClosePanel() {
    this.geofenceService.setVisiblePanelGeofences(false);
  }

  onCardClicked(id: any) {
    this.panelGeofencesService.setLoading(true);
    console.log("Card Clicked", id);
    this.fullScreen = false;
    //Update Detail Geofence
    this.UpdateDetailGeofence(id);
  }

  UpdateDetailGeofence($identifier: any) {
    this.panelDetailGeofencesService.setLoading(true);
    this.subscription_get = this.geofenceService.get($identifier).subscribe(
      (data: EstatusJSON) => {
        if (data.isSuccess == true) {
          this.panelDetailGeofencesService.setLoading(false);
          console.log("PIN SELECTED");
          this.panelDetailGeofencesService.setGuid(data.result.guid);
          this.panelDetailGeofencesService.setVisibilityPopup(true);
          this.panelDetailGeofencesService.setTitle(data.result.name);
          this.panelDetailGeofencesService.setSubtitle("Detalle de Geocerca");
          this.panelDetailGeofencesService.setData(data.result.data);
          this.PinSelected = data.result;
          this.mapHelperService.FitBounds(JSON.parse(data.result.geom_GeoJSON).features[0].geometry);
          this.panelGeofencesService.setLoading(false);
        }else{
          this.panelGeofencesService.setLoading(false);
          this.panelDetailGeofencesService.setLoading(false);
          this.toastService.error("Error al obtener la geocerca");
        }
      }
    );
    this.geofenceService.setVisiblePanelDetailGeofences(true);
  }

  GetGeofences() {
    setTimeout(() => {
      this.subscription_GetAllGeofencesGeoJson = this.geofencesService
        .getAllGeofencesGeoJson()
        .subscribe((data: EstatusJSON) => {
          if (data.isSuccess == true) {
            this.dataGeoJson = JSON.parse(data.result);
            console.log("UPDATING LAYER...");
            console.log(data.result);
            this.mapHelperService.UpdateLayerGeoJson(
              "geofencesSource",
              this.dataGeoJson
            );
          }
          this.isLoading = false;
        });
    }, 1500);
  }
}
